import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-order-status-modal',
  imports: [MatDialogModule, TranslocoModule],
  templateUrl: './order-status-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './order-status-modal.component.css',
})
export class OrderStatusModalComponent {
  constructor(public dialog: MatDialog) { }
}
